export default __webpack_public_path__ + "static/media/ld.0abacba9.gif";